// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuSearchOption{
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-top: 5%;
}
.compactInputForm{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 70%;
    height: 70%;
}
.InputForm{
    border-color: #b3b3b3 !important;
    /* border-color: #ee085c; */
width: 100%;
height: 100%;
border-top: none !important;
border-left: none !important;
border-radius: 5px;
background-color: #00000029 !important;
color: aliceblue !important;
outline: none;
letter-spacing: 1px;
 text-align: center;
}
.InputForm:focus{
    border-color: #ffffff !important;
    box-shadow: 1px 1px 10px #ffffff4d;
}
.react-select__input,.react-select__placeholder{
    background-color: transparent !important;
    color: var(--txt-color) !important;
    border: none !important;
    outline: 0 !important;
    font-size: var(--font-size-small);
}
.react-select-container{
    outline: 0 !important;
    top: 5px;
}
.react-select__input-container,.react-select__single-value {
    /* color: aliceblue !important; */
    color: var(--txt-color) !important;
}
.react-select__indicator svg{
    /* color: #088eee ; */
    color: var(--txt-color);
 }

.labelInputForm{
    font-weight: bold;
    position: absolute;
    /* top: -20%; */
    color: #eaeaea;
    
    /* color:  #ee085c; */
}
.react-select__menu{
    border-color:#088eee !important;;
    background-color:var(--white-color) !important ;
    color: #088eee !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    display: flex !important;
    text-align: center !important;
    z-index: 3 !important;
}
.react-select__menu-list{
    width: 100% !important;
}
.react-select__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
}
option:hover{
    background-color:#fff ;
    color: #ee085c;
}
.css-t3ipsp-control:hover{
    

    box-shadow: none !important;
}

.css-t3ipsp-control{
    

    box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/InputForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;AACA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B,WAAW;AACX,YAAY;AACZ,2BAA2B;AAC3B,4BAA4B;AAC5B,kBAAkB;AAClB,sCAAsC;AACtC,2BAA2B;AAC3B,aAAa;AACb,mBAAmB;CAClB,kBAAkB;AACnB;AACA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;AACA;IACI,wCAAwC;IACxC,kCAAkC;IAClC,uBAAuB;IACvB,qBAAqB;IACrB,iCAAiC;AACrC;AACA;IACI,qBAAqB;IACrB,QAAQ;AACZ;AACA;IACI,iCAAiC;IACjC,kCAAkC;AACtC;AACA;IACI,qBAAqB;IACrB,uBAAuB;CAC1B;;AAED;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;;IAEd,qBAAqB;AACzB;AACA;IACI,+BAA+B;IAC/B,+CAA+C;IAC/C,yBAAyB;IACzB,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA0D;AAC9D;AACA;IACI,sBAAsB;IACtB,cAAc;AAClB;AACA;;;IAGI,2BAA2B;AAC/B;;AAEA;;;IAGI,2BAA2B;AAC/B","sourcesContent":[".menuSearchOption{\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding-top: 5%;\r\n}\r\n.compactInputForm{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 70%;\r\n    height: 70%;\r\n}\r\n.InputForm{\r\n    border-color: #b3b3b3 !important;\r\n    /* border-color: #ee085c; */\r\nwidth: 100%;\r\nheight: 100%;\r\nborder-top: none !important;\r\nborder-left: none !important;\r\nborder-radius: 5px;\r\nbackground-color: #00000029 !important;\r\ncolor: aliceblue !important;\r\noutline: none;\r\nletter-spacing: 1px;\r\n text-align: center;\r\n}\r\n.InputForm:focus{\r\n    border-color: #ffffff !important;\r\n    box-shadow: 1px 1px 10px #ffffff4d;\r\n}\r\n.react-select__input,.react-select__placeholder{\r\n    background-color: transparent !important;\r\n    color: var(--txt-color) !important;\r\n    border: none !important;\r\n    outline: 0 !important;\r\n    font-size: var(--font-size-small);\r\n}\r\n.react-select-container{\r\n    outline: 0 !important;\r\n    top: 5px;\r\n}\r\n.react-select__input-container,.react-select__single-value {\r\n    /* color: aliceblue !important; */\r\n    color: var(--txt-color) !important;\r\n}\r\n.react-select__indicator svg{\r\n    /* color: #088eee ; */\r\n    color: var(--txt-color);\r\n }\r\n\r\n.labelInputForm{\r\n    font-weight: bold;\r\n    position: absolute;\r\n    /* top: -20%; */\r\n    color: #eaeaea;\r\n    \r\n    /* color:  #ee085c; */\r\n}\r\n.react-select__menu{\r\n    border-color:#088eee !important;;\r\n    background-color:var(--white-color) !important ;\r\n    color: #088eee !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    z-index: 3 !important;\r\n}\r\n.react-select__menu-list{\r\n    width: 100% !important;\r\n}\r\n.react-select__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n}\r\noption:hover{\r\n    background-color:#fff ;\r\n    color: #ee085c;\r\n}\r\n.css-t3ipsp-control:hover{\r\n    \r\n\r\n    box-shadow: none !important;\r\n}\r\n\r\n.css-t3ipsp-control{\r\n    \r\n\r\n    box-shadow: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
